import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getAllDueRepayment = async ({
  pageNumber,
  size,
  aggregatorId,
  LoanRef,
  MinDateDue,
  PastDue,
}) => {
  let queryParams = `Page=${pageNumber}&PageSize=${size}&AggregatorId=${aggregatorId}`;
  if (PastDue) {
    queryParams = `${queryParams}&PastDue=${PastDue}`;
  }
  if (MinDateDue) {
    queryParams = `${queryParams}&MinDateDue=${MinDateDue}`;
  }
  if (LoanRef) {
    queryParams = `${queryParams}&LoanRef=${LoanRef}`;
  }
  const data = await getData(
    `${ajaxEndpoints.GET_ALL_DUE_LOAN_REPAYMENT}?${queryParams}`
  );
  return data;
};

export default function useAllDueRepayment({
  pageNumber,
  size,
  aggregatorId,
  LoanRef,
  MinDateDue,
  PastDue,
}) {
  return useQuery(
    [
      { pageNumber, size, aggregatorId, LoanRef, MinDateDue, PastDue },
      "getAllDueRepayment",
    ],
    getAllDueRepayment,
    {
      enabled: aggregatorId ? true : false,
      refetchOnWindowFocus: false,
    }
  );
}
